export default "__VITE_ASSET__a9c2eb2f__"